import React from "react";
import { Table, TableCell, TableRow } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { ElementTag } from "./ElementTag";
import { TableContext } from "./useTable";
import { TableRowEditor } from "./TableRowEditor";

export function TableEditor(props: {
	table: Table,
}) {
	const designer = useDesigner();

	// const parentCell = useTableCell();

	const tableState = React.useMemo(() => {

		function addRow(relativeTo: TableCell, offset: number) {
			const cellContext = designer.getContext(relativeTo.id!);
			if (!cellContext) return;

			const row = cellContext.parent.def as TableRow;
			if (!row) return;

			const newRow = designer.createItem("tableRow", row) as TableRow;
			for(let i=0;i<props.table.cols.length;i++) {
				const cell = designer.createItem("tableCell") as TableCell;
				newRow.cells.push(cell);
			}

			designer.addItem(newRow, props.table.rows, row, offset);

			// what is index of cell currently in?
			const cellIndex = row.cells.indexOf(relativeTo);

			if (cellIndex >= 0) {
				// once everything re-rendered we want the new para to be focused
				designer.setFocus(newRow.cells[cellIndex].content[0]);
			}

			designer.refreshItem(props.table);

			return newRow;
		}

		function addCol(relativeTo: TableCell, offset: number) {
			const cellContext = designer.getContext(relativeTo.id!);
			if (!cellContext) return;

			const row = cellContext.parent.def as TableRow;
			if (!row) return;

			// what is the index of this cell?
			const cellIndex = row.cells.indexOf(relativeTo);

			// add the col def
			props.table.cols.splice(cellIndex+offset, 0, {
				widthPercent: 10,
				id: designer.nextID(),
			});

			// have to insert a cell on every row 
			for(let r of props.table.rows) {
				const cell = designer.createItem("tableCell") as TableCell;
				r.cells.splice(cellIndex+offset, 0, cell);
			}

			// once everything re-rendered we want the new para to be focused
			designer.setFocus(row.cells[cellIndex + offset].content[0]);

			designer.refreshItem(props.table);
		}		

		return {
			table: props.table,
			
			addRowAbove: function(relativeTo: TableCell) {
				return addRow(relativeTo, 0);
			},

			addRowBelow: function(relativeTo: TableCell) {
				return addRow(relativeTo, 1);
			},

			addColAfter: function(relativeTo: TableCell) {
				addCol(relativeTo, 1);
			},

			addColBefore: function(relativeTo: TableCell) {
				addCol(relativeTo, 0);
			},

		};
	}, [designer, props.table]);

	const rows = [];
	for(let r of props.table.rows) {
		if (!r.id) r.id = designer.nextID();
		if (r.type !== "tableRow") r.type = "tableRow";

		rows.push(
			<TableRowEditor row={r} key={r.id} />
		);
	}

	const elementContext = useElementContext(props.table);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const style = designer.createStyle(props.table);

	return (
		<ElementContext.Provider value={elementContext}>
			<TableContext.Provider value={tableState}>
				<div
					className={"table-editor content-element " + state.classes + (props.table.hideBorders ? " hide-borders" : "")}
					data-key={props.table.id}
					id={state.elementID}
					style={style}
					key={state.token}
					tabIndex={0}
				>
					<ElementTag />
					<table
					>
						<tbody>
							{rows}
						</tbody>
					</table>
				</div>
			</TableContext.Provider>
		</ElementContext.Provider>
	);
}
